/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState, USER_KEY } from './user.reducer';

const getState = createFeatureSelector<UserState>(USER_KEY);
export const getUserState = createSelector(getState, (state: UserState) => state);
